export enum HttpStatus {
  Forbidden = 403
}
